class TrieNode {
    constructor() {
        this.children = {};
        this.isEndOfWord = false;
        this.metaData = {};
    }
}

export default TrieNode;
